import { AdminPanelType } from '@root-gipro/modules/AdminPanel/interfaces/admin-panel.actions'
import {
  TAddAdminOAModal, 
  TCreateAdminObjectAnalog,
  TDeleteAdminOA,
  TDeleteAdminOAModal,
  TGetAdminObjectsAnalog,
  TSetTAdminObjectsAnalogCommon, 
  TUpdateTAdminObjectsAnalog
} from '@root-gipro/modules/AdminPanel/interfaces/adminObjectsAnalog'

export const setAdminObjectsAnalogCommon = (params: TSetTAdminObjectsAnalogCommon) => ({
	type: AdminPanelType.SET_ADMIN_OBJECTS_ANALOG_COMMON,
	params,
});

export const updateAdminObjectsAnalog = (params: TUpdateTAdminObjectsAnalog) => ({
	type: AdminPanelType.UPDATE_ADMIN_OBJECTS_ANALOG,
	params,
});

export const getAdminObjectsAnalog = (params: TGetAdminObjectsAnalog) => ({
	type: AdminPanelType.GET_ADMIN_OBJECTS_ANALOG,
	params
});

export const setAdminDeleteModalOA = (params: TDeleteAdminOAModal|null) => ({
	type: AdminPanelType.SET_ADMIN_DELETE_MODAL_OA,
	params
});

export const deleteAdminObjectAnalog = (params: TDeleteAdminOA) => ({
	type: AdminPanelType.DELETE_ADMIN_OA,
	params
});

export const setDeletedAdminObjectAnalog = (params: TDeleteAdminOA) => ({
	type: AdminPanelType.SET_DELETED_ADMIN_OA,
	params
});

export const setAdminAddModalOA = (params: TAddAdminOAModal|null) => ({
  type: AdminPanelType.SET_ADMIN_ADD_MODAL_OA,
  params
});

export const createAdminOA = (params: TCreateAdminObjectAnalog) => ({
  type: AdminPanelType.CREATE_ADMIN_OA,
  params
});
